/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioMicAIcon24Regular = forwardRef('MediaAudioMicAIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1.25A4.75 4.75 0 0 0 7.25 6v6a4.75 4.75 0 1 0 9.5 0V6A4.75 4.75 0 0 0 12 1.25ZM8.75 6a3.25 3.25 0 0 1 6.5 0v6a3.25 3.25 0 0 1-6.5 0V6Z" }),
        React.createElement("path", { d: "M5 10a.75.75 0 0 1 .75.75V12a6.25 6.25 0 1 0 12.5 0v-1.25a.75.75 0 0 1 1.5 0V12a7.75 7.75 0 0 1-7 7.714V21.5h3.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5h3.5v-1.786a7.75 7.75 0 0 1-7-7.714v-1.25A.75.75 0 0 1 5 10Z" })));
});
